import router from '../router/router'
import store from '../store/store'

const axios = require('axios')

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json;charset=UTF-8',
  },
});

instance.interceptors.request.use(config => {
  const accessToken = store.getters.token;
  if (accessToken) {
    config.headers['Authorization'] = 'Bearer '+accessToken;
  }
  return config
}, function(error) {
  return Promise.reject(error)
})

instance.interceptors.response.use(response => {
    return response
  }, error => {
    if (error.response && error.response.status === 401) {
      // 認証切れ → ストアをクリアしてログイン画面へ
      store.dispatch('logout');
      const currentPath = router.currentRoute.value?.path || '';
      if (currentPath.startsWith('/timecard')) {
        router.push({ name: 'TimecardLogin' });
      } else {
        router.push({ name: 'Login' });
      }
    }
    return Promise.reject(error)
  })

export default instance;
